// SPEC-064: whether a plan comes with a free trial is read from the API —
// PlanSerializer sends `trial: null` for a plan without one and a duration
// string ("8 days") otherwise — never from the plan's name or id. Only the
// presence is used: the customer-facing copy stays "7-Day" until the 7-vs-8
// question is settled deliberately (SPEC-064 Q1). A plan object that lacks
// the field altogether (older persisted state, hand-built fixtures) keeps
// today's trial copy rather than silently dropping it.
const planOffersTrial = (plan) => plan?.trial !== null

export default planOffersTrial
